const styles = {
  style: {
    backgroundColor: '#222222',
    width: '400px',
    margin: 20,
    right: 0,
    left: 'auto',
    borderRadius: 10,
    flexDirection: 'column',
    display: 'block',
    color: '#828282',
    fontSize: 14,
  },
  title: {
    color: 'white',
    fontSize: 18,
    fontWeight: '500',
    marginBottom: 5,
  },
  buttonStyle: {
    display: 'flex',
    margin: '0 auto 15px',
    backgroundColor: 'transparent',
    fontWeight: '500',
    color: '#FF4900',
  },
  contentStyle: {
    margin: '30px 30px 15px 30px',
  },
  mobileStyle: {
    backgroundColor: '#222222',
    width: '90%',
    margin: '10px 20px',
    right: 0,
    left: 'auto',
    borderRadius: 10,
    flexDirection: 'column',
    display: 'block',
    color: '#828282',
    fontSize: 14,
  },
  mobileTitle: {
    color: 'white',
    fontSize: 18,
    fontWeight: '500',
    marginBottom: 5,
    textAlign: 'center',
  },
};

export default styles;
